import AdminLayout from "components/layout/AdminLayout"
import MarketingLayout from "components/layout/MarketingLayout"
import DiscountCodeList from "components/marketing/discountCodes/CodeList"
import { ReactElement } from "react"

const DiscountCodeListPage = () => {
  return <DiscountCodeList />
}

DiscountCodeListPage.getLayout = (page: ReactElement) => {
  return (
    <AdminLayout>
      <MarketingLayout>{page}</MarketingLayout>
    </AdminLayout>
  )
}

export default DiscountCodeListPage
